import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical';

export interface SelectBoldPayload {
  isBold: boolean;
}

export const SELECT_BOLD: LexicalCommand<SelectBoldPayload> = createCommand();

export function BoldPlugin({ onChange }: { onChange?: (isBold: boolean) => void }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<SelectBoldPayload>(
        SELECT_BOLD,
        ({ isBold }) => {
          onChange?.(isBold);

          return true;
        },
        COMMAND_PRIORITY_EDITOR
      )
    );
  }, [editor, onChange]);

  return null;
}
